import {
  cleanSearchData,
  getDottedQuestionName,
  getQuestionsOptionsList,
  searchToFilterLogic
} from '@aytm/app/stats/page/comments/lib/utils'
import { DEFAULT_SELECTED_QUESTION } from '@aytm/app/stats/page/comments/lib/constants'

export const mapSearchDataForFetch = ({
  query = {},
  selectedQuestion = DEFAULT_SELECTED_QUESTION,
  pageSize = 10,
  orderBy = 'time',
  orderDirection = 'asc',
  translation = '*',
  currentPage = 1,
  isQAMode = false,
  nocache = false,
  includeSchema = false,
  includeFilter = false,
  flattenAnswers = false,
  uidsToApprove = null,
  responsesOptions = null
}) => {
  const data = {
    pageSize,
    page: currentPage,
    includeSchema
  }

  let search = {}
  if (null !== query) {
    const da = cleanSearchData(query)
    search = Object.assign(search, { query: da })
  }
  if (selectedQuestion != DEFAULT_SELECTED_QUESTION) {
    search = Object.assign(search, { scope: getDottedQuestionName(selectedQuestion) })
  }
  if (null !== orderBy) {
    search = Object.assign(search, { order: orderBy, direction: orderDirection })
  }

  if ('*' != translation) Object.assign(search, { lang: translation })

  if (isQAMode) {
    Object.assign(data, {
      pageSize: 1 === pageSize ? 10 : pageSize,
      currentPage: 1,
      qaMode: true
    })
    if (uidsToApprove) {
      data.qaModeApprove = uidsToApprove.reduce((ret, item) => {
        ret.push(item.uid)
        return ret
      }, [])
    }
  }

  if (nocache) {
    Object.assign(data, { nocache: true })
  }

  if (flattenAnswers) {
    Object.assign(data, { flattenAnswers: true })
  }

  if (includeSchema) {
    Object.assign(data, { includeAssets: ['hm.cluster'] })
  }

  if (includeFilter && null !== responsesOptions) {
    const { survey, reportVirtual, reportSchema } = responsesOptions
    const questionsList = getQuestionsOptionsList(survey, reportVirtual, reportSchema).toJS()
    Object.assign(data, { filter: searchToFilterLogic(query, selectedQuestion, questionsList) })
  }

  return Object.assign(data, Object.keys(search).length ? { search } : void 0)
}

export default {
  mapSearchDataForFetch: mapSearchDataForFetch
}
